import {
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAIL,
  CREATE_DOCUMENT,
  CREATE_DOCUMENT_SUCCESS,
  CREATE_DOCUMENT_FAIL,
  GET_DOCUMENT,
  GET_DOCUMENT_SUCCESS,
  GET_DOCUMENT_FAIL,
  UPDATE_DOCUMENT,
  UPDATE_DOCUMENT_SUCCESS,
  UPDATE_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  ASSIGN_DOCUMENT_COMPANIES,
  ASSIGN_DOCUMENT_COMPANIES_SUCCESS,
  ASSIGN_DOCUMENT_COMPANIES_FAIL,
  CLEAR_DOCUMENT_ERRORS,
  CLEAR_DOCUMENTS,
  GET_MY_DOCUMENTS,
  GET_DOCUMENTS_ALL_FAIL,
  GET_DOCUMENTS_ALL_SUCCESS,
  GET_DOCUMENTS_ALL
} from "./actionTypes"

const INIT_STATE = {
  items: [],
  pagination: { page: 1, limit: 10, totalPages: 1, total: 0 },
  loading: false,

  allDocuments: [],

  creating: false,
  updating: false,
  deleting: false,

  getDocumentLoading: false,
  document: null,

  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  assigning: false,
  assignSuccess: false,

  error: null,
  message: null,
}

const Documents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DOCUMENTS:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
        createSuccess: false,
        updateSuccess: false
      }
    case GET_MY_DOCUMENTS:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
        createSuccess: false,
        updateSuccess: false
      }
    case GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        pagination: action.payload.pagination || INIT_STATE.pagination,
      }
    case GET_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload
      }

    case GET_DOCUMENTS_ALL:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
        createSuccess: false,
        updateSuccess: false
      }
    case GET_DOCUMENTS_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        allDocuments: action.payload.items || [],
      }
    case GET_DOCUMENTS_ALL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload
      }

    case CREATE_DOCUMENT:
      return {
        ...state, creating: true,
        createSuccess: false,
        error: null
      }
    case CREATE_DOCUMENT_SUCCESS:
      return {
        ...state,
        creating: false,
        createSuccess: true,
        document: action.payload?.data || null
      }
    case CREATE_DOCUMENT_FAIL:
      return {
        ...state,
        creating: false,
        error: action.payload,
        message: action.payload
      }

    case GET_DOCUMENT:
      return {
        ...state,
        getDocumentLoading: true, error: null
      }
    case GET_DOCUMENT_SUCCESS:
      return {
        ...state,
        getDocumentLoading: false, document: action.payload?.document || action.payload
      }
    case GET_DOCUMENT_FAIL:
      return {
        ...state,
        getDocumentLoading: false,
        error: action.payload,
        message: action.payload
      }

    case UPDATE_DOCUMENT:
      return {
        ...state,
        updating: true,
        updateSuccess: false, error: null

      }
    case UPDATE_DOCUMENT_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true

      }
    case UPDATE_DOCUMENT_FAIL:
      return {
        ...state,
        updating: false,
        error: action.payload,
        message: action.payload

      }

    case DELETE_DOCUMENT:
      return {
        ...state,
        deleting: true,
        deleteSuccess: false,
        error: null

      }
    case DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleteSuccess: true
      }
    case DELETE_DOCUMENT_FAIL:
      return {
        ...state,
        deleting: false,
        error: action.payload,
        message: action.payload
      }

    case ASSIGN_DOCUMENT_COMPANIES:
      return {
        ...state,
        assigning: true,
        assignSuccess: false,
        error: null
      }
    case ASSIGN_DOCUMENT_COMPANIES_SUCCESS:
      return {
        ...state,
        assigning: false,
        assignSuccess: true
      }
    case ASSIGN_DOCUMENT_COMPANIES_FAIL:
      return {
        ...state,
        assigning: false,
        error: action.payload,
        message: action.payload
      }

    case CLEAR_DOCUMENT_ERRORS:
      return {
        ...state,
        error: null,
        message: null
      }

    case CLEAR_DOCUMENTS:
      return {
        ...state,
        items: [],
      }

    default:
      return state
  }
}

export default Documents
